/*
  Proyecto FÉNIX — v69.15
  Fix puntual para botones Grid/List en colecciones.
  Sin observers, sin loops, sin tocar producto/carrito/checkout.
*/
(function(){
  'use strict';

  var lastActivation = 0;

  function closestChangeView(target){
    if (!target || !target.closest) return null;
    return target.closest('.collection-view .change-view');
  }

  function buildViewUrl(view){
    var url;
    try {
      url = new URL(window.location.href);
      url.searchParams.set('view', view);
      return url.toString();
    } catch (err) {
      var href = window.location.href;
      var joiner = href.indexOf('?') > -1 ? '&' : '?';
      return href + joiner + 'view=' + encodeURIComponent(view);
    }
  }

  function activateView(event){
    var btn = closestChangeView(event.target);
    if (!btn) return;

    var view = btn.getAttribute('data-view');
    if (!view) return;

    var now = Date.now();
    if (now - lastActivation < 650) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return;
    }

    lastActivation = now;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    btn.setAttribute('aria-busy', 'true');
    window.location.href = buildViewUrl(view);
  }

  document.addEventListener('click', activateView, true);
  document.addEventListener('touchend', activateView, { capture:true, passive:false });
})();
